module.exports = __webpack_public_path__ + "img/loader-gray.ac262547.gif";